/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Cc_Move_Right_One_CharacterInputs */



/**
* | output |
* | --- |
* | "Move Right 1 Character" |
*
* @param {Shortcut_Keys_Name_Cc_Move_Right_One_CharacterInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_cc_move_right_one_character = /** @type {((inputs?: Shortcut_Keys_Name_Cc_Move_Right_One_CharacterInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Cc_Move_Right_One_CharacterInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Deplacer d'un caractere vers la droite")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ein Zeichen nach rechts rücken")
	if (locale === "it") return /** @type {LocalizedString} */ ("Spostati di 1 carattere a destra")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Переместиться на 1 символ вправо")
	if (locale === "es") return /** @type {LocalizedString} */ ("Mover 1 carácter a la derecha")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("向右移动一个字符")
	if (locale === "ja") return /** @type {LocalizedString} */ ("1文字右に移動")
	if (locale === "hi") return /** @type {LocalizedString} */ ("एक वर्ण दाएं जाएं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Mover um caractere para a direita")
	return /** @type {LocalizedString} */ ("Move Right 1 Character")
});